// POST /feedback — wraps the middleware route that hands off to the
// harness's log_feedback. Writes land in query_feedback exactly where
// the old web tool wrote them, so admin dashboards keep working.

import { api } from "./base";

export interface FeedbackBody {
  organization: string;
  raw_query: string;
  rating: "good" | "bad";
  notes?: string;
}

export async function postFeedback(bearer: string, body: FeedbackBody): Promise<void> {
  const resp = await fetch(api("/feedback"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${bearer}`,
    },
    body: JSON.stringify(body),
  });
  if (!resp.ok) {
    const text = await resp.text().catch(() => "");
    throw new Error(`/feedback returned ${resp.status}: ${text}`);
  }
}
